export default __webpack_public_path__ + "static/media/ms-original.336825c6.png";